import { jwtDecode } from 'jwt-decode';

// Lightweight logged-in check derived from the stored auth token. The backend
// always resolves the real user from the Bearer token, so `email` here is only
// used to gate UI and key react-query caches — a null email while logged in is
// harmless (queries still run; the server knows who you are).
export function getCurrentUser() {
  const token = localStorage.getItem('authToken');
  if (!token) return { isLoggedIn: false, email: null };
  try {
    const decoded = jwtDecode(token);
    return { isLoggedIn: true, email: decoded.email || null };
  } catch {
    return { isLoggedIn: true, email: null };
  }
}
